
const usedInCondition = (fieldId, conditions) => {
  return !!((conditions || []).find(c => {
    const left = c.left || {};
    return left.type === 'field' && left.value === fieldId;
  }));
};

const fieldConditionService = {
  usedInCondition,
};
export default fieldConditionService;
